module.exports = __webpack_public_path__ + "img/martinique.42d3af6.webp";